import { CapitalRasingHistoryDataTypes, CapitalRasingHistoryParamsTypes, CapitalRasingHistoryTypes } from './types';

import axiosInstance from 'services/common/instance';

const getCapitalRasingHistoryList = async (
  code: string,
): Promise<CapitalRasingHistoryTypes[]> => {
  const response = await axiosInstance.get(`ttpt-capital-raising-histories?stock_symbol=${code}`);
  return response.data.data;
};

export default getCapitalRasingHistoryList;

// Bank
export const getTtptStoxTBFundBankCapitalRaisingHistorService = async (
  params: CapitalRasingHistoryParamsTypes,
): Promise<PaginationData<CapitalRasingHistoryDataTypes[]>> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-bank/capital-raising-history', { params });
  return res.data;
};

// Insurance
export const getTtptStoxTBFundInsuranceCapitalRaisingHistorService = async (
  params: CapitalRasingHistoryParamsTypes,
): Promise<PaginationData<CapitalRasingHistoryDataTypes[]>> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-insurance/capital-raising-history', { params });
  return res.data;
};

// Securities
export const getTtptStoxTBFundSecuritiesCapitalRaisingHistorService = async (
  params: CapitalRasingHistoryParamsTypes,
): Promise<PaginationData<CapitalRasingHistoryDataTypes[]>> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-securities/capital-raising-history', { params });
  return res.data;
};

// Company
export const getTtptStoxTBFundCompanyCapitalRaisingHistorService = async (
  params: CapitalRasingHistoryParamsTypes,
): Promise<PaginationData<CapitalRasingHistoryDataTypes[]>> => {
  const res = await axiosInstance.get('ttpt-stox-tb-fund-company/capital-raising-history', { params });
  return res.data;
};
